import { render, staticRenderFns } from "./SplitBallotProgress.vue?vue&type=template&id=873807da&scoped=true&"
import script from "./SplitBallotProgress.vue?vue&type=script&lang=js&"
export * from "./SplitBallotProgress.vue?vue&type=script&lang=js&"
import style0 from "./SplitBallotProgress.vue?vue&type=style&index=0&id=873807da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873807da",
  null
  
)

export default component.exports